import React from "react";
import { withStyles } from "@material-ui/styles";
import Tab from "@material-ui/core/Tab";

interface Props {
  label: string;
  value: number;
}

const KTab = withStyles((theme) => ({
  root: {
    minHeight: "26px",
    maxWidth: "100%",
    minWidth: "12px",
    textTransform: "none",
    padding: 0,
    marginRight: "24px",
    ...theme.typography.body2,
    color: theme.palette.common.black,
  },
  wrapper: {
    width: "inherit",
    minWidth: "inherit",
  },
  selected: {
    fontWeight: 500,
  },
}))((props: Props) => <Tab disableRipple {...props} />);

export default KTab;
